import { alpha } from '@mui/material/styles';

export const sharedStyles = {
  formContainer: {
    width: '100%',
    maxWidth: '100%',
  },
  stepTitle: {
    mb: 3,
    color: '#ba0d36',
    fontWeight: 'medium',
    fontSize: { xs: '1.5rem', sm: '1.75rem' },
  },
  gridContainer: {
    spacing: { xs: 2, sm: 3 },
  },
  inputProps: {
    size: "small",
    sx: {
      '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
          borderColor: '#ba0d36',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#ba0d36',
          borderWidth: 2,
        },
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: '#ba0d36',
      },
      '& .MuiInputAdornment-root .MuiSvgIcon-root': {
        color: '#ba0d36',
      },
    },
  },
  buttonContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    gap: 2,
    padding: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
    zIndex: 1000,
  },
  primaryButton: {
    py: 1,
    px: 3,
    fontSize: '0.9rem',
    textTransform: 'none',
    boxShadow: 2,
    backgroundColor: '#ba0d36',
    '&:hover': {
      backgroundColor: '#d13d5f',
      boxShadow: 4,
    },
  },
  secondaryButton: {
    py: 1,
    px: 3,
    fontSize: '0.9rem',
    textTransform: 'none',
    boxShadow: 1,
    borderColor: '#ba0d36',
    color: '#ba0d36',
    '&:hover': {
      borderColor: '#d13d5f',
      color: '#d13d5f',
      boxShadow: 2,
      backgroundColor: 'rgba(186, 13, 54, 0.04)',
    },
  },
  submitButton: {
    py: 1,
    px: 3,
    fontSize: '0.9rem',
    textTransform: 'none',
    boxShadow: 2,
    backgroundColor: '#ba0d36',
    '&:hover': {
      backgroundColor: '#d13d5f',
      boxShadow: 4,
    },
  },
  formContent: {
    pb: '80px',
  },
  card: {
    p: 3,
    borderRadius: 2,
    boxShadow: `0 2px 8px ${alpha('#ba0d36', 0.1)}`,
    '&:hover': {
      boxShadow: `0 4px 12px ${alpha('#ba0d36', 0.15)}`,
    },
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 'medium',
    color: '#ba0d36',
    mb: 2,
  },
  helperText: {
    fontSize: '0.875rem',
    color: 'text.secondary',
    mt: 1,
  },
  errorText: {
    color: '#ba0d36',
    fontSize: '0.875rem',
    mt: 0.5,
  },
  divider: {
    my: 3,
    opacity: 0.5,
  },
  radioGroup: {
    '& .MuiFormControlLabel-root': {
      marginRight: 4,
    },
    '& .MuiRadio-root': {
      color: '#ba0d36',
      '&.Mui-checked': {
        color: '#ba0d36',
      },
    },
  },
}; 